import React, { useState } from 'react';
import videoCallPreview from '../../../../../../assets/images/graphics/video_call_preview.png';

export const FinalSubmitCard: React.FC = () => {
  const [submitted, setSubmitted] = useState(false);

  if (submitted) {
    return (
      <div className='w-full rounded-2xl border border-gray-100 bg-white shadow-sm overflow-hidden text-left'>
        <div className='flex flex-col items-center justify-center py-10 gap-3 px-6'>
          <div className='w-14 h-14 rounded-full bg-emerald-100 flex items-center justify-center animate-bounce shadow-inner'>
            <svg className='w-7 h-7 text-emerald-600' fill='none' stroke='currentColor' strokeWidth={3} viewBox='0 0 24 24'>
              <path strokeLinecap='round' strokeLinejoin='round' d='M5 13l4 4L19 7' />
            </svg>
          </div>
          <div className='text-center'>
            <p className='text-[14px] font-bold text-gray-800'>Final Submission Sent!</p>
            <p className='text-[11px] text-gray-400 mt-1 uppercase tracking-wider font-semibold'>Question completed</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className='w-full rounded-2xl border border-gray-100 bg-white shadow-sm overflow-hidden text-left'>
      { /* ── Action Header ── */ }
      <div className='px-4 pt-4 pb-2 bg-gray-50/50 border-b border-gray-100'>
        <div className='flex items-center justify-between mb-1'>
          <span className='px-2.5 py-0.5 rounded-full bg-blue-50 text-[10px] font-bold text-blue-600 border border-blue-100 uppercase tracking-tight'>
            Final Step
          </span>
          <span className='text-[10px] text-gray-400 font-medium'>Review & Confirm</span>
        </div>
        <p className='text-[12px] font-semibold text-gray-800 leading-tight'>
          Finalize your response and proceed to the next question.
        </p>
      </div>

      <div className='grid grid-cols-2 gap-3 p-4'>
        { /* Left – Playback Status Preview */ }
        <div className='flex flex-col gap-2'>
          <div className='relative bg-black rounded-xl overflow-hidden shadow-md' style={{ aspectRatio: '16/10' }}>
            <div className='absolute inset-0 flex items-center justify-center bg-gradient-to-br from-gray-900 via-gray-800 to-black'>
              <img
                  src={videoCallPreview}
                  alt='Professional Video Call'
                  className='h-full w-auto opacity-60 object-contain grayscale-[0.3]'
              />
              <div className='absolute inset-0 bg-blue-500/5 mix-blend-overlay'></div>
            </div>

            { /* Playback status indicator */ }
            <div className='absolute inset-0 flex flex-col items-center justify-center gap-1 bg-black/20 backdrop-blur-[1px]'>
              <div className='w-9 h-9 rounded-full bg-white/20 flex items-center justify-center border border-white/30 backdrop-blur-md'>
                <svg className='w-4 h-4 text-white' fill='currentColor' viewBox='0 0 24 24'>
                  <path d='M8 5v14l11-7z' />
                </svg>
              </div>
              <span className='text-[9px] text-white font-bold tracking-widest uppercase'>Review Saved</span>
            </div>
          </div>

          <div className='bg-gray-50 rounded-lg p-2 border border-gray-100'>
            <div className='flex items-center gap-1.5'>
              <div className='w-1.5 h-1.5 rounded-full bg-emerald-500'></div>
              <p className='text-[9px] font-bold text-gray-700 uppercase'>Encoding Ready</p>
            </div>
            <p className='text-[8px] text-gray-400 mt-0.5'>Video version 1.0 captured</p>
          </div>
        </div>

        { /* Right – Decision Panel */ }
        <div className='flex flex-col justify-between py-1'>
          <div className='space-y-3'>
            <div className='bg-amber-50 rounded-lg p-2.5 border border-amber-100'>
              <div className='flex items-center gap-1.5 mb-1'>
                <svg className='w-3 h-3 text-amber-500' fill='currentColor' viewBox='0 0 20 20'>
                  <path fillRule='evenodd' d='M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z' clipRule='evenodd' />
                </svg>
                <p className='text-[10px] font-bold text-amber-700 uppercase leading-none'>Change Mind?</p>
              </div>
              <p className='text-[9px] text-amber-600 leading-snug'>
                Not happy? You can redo before hitting submit.
              </p>
              <button
                  className='mt-2 w-full py-1.5 rounded-lg border border-amber-200 bg-white text-[9px] font-bold text-amber-600 hover:bg-amber-50 transition-colors uppercase tracking-wide'
              >
                Redo Recording
              </button>
            </div>

            <div className='bg-emerald-50 rounded-lg p-2.5 border border-emerald-100'>
              <div className='flex items-center gap-1.5 mb-1'>
                <svg className='w-3 h-3 text-emerald-500' fill='currentColor' viewBox='0 0 20 20'>
                  <path fillRule='evenodd' d='M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z' clipRule='evenodd' />
                </svg>
                <p className='text-[10px] font-bold text-emerald-700 uppercase leading-none'>Ready to go!</p>
              </div>
              <p className='text-[9px] text-emerald-600 leading-snug'>
                Confirm your response is complete.
              </p>
              <button
                  onClick={() => setSubmitted(true)}
                  className='mt-2 w-full py-2 rounded-lg bg-emerald-500 text-[10px] font-extrabold text-white hover:bg-emerald-600 shadow-sm shadow-emerald-200 transition-all active:scale-95 uppercase tracking-widest'
              >
                Submit Now
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
